import { createAction, props } from '@ngrx/store';
import { IDropDownList } from '@interfaces';

export const loadWorkArea = createAction('[Work Area] Load Work Area');
export const loadWorkAreaSuccess = createAction(
  '[Work Area] Load Work Area Success',
  props<{ workArea: IDropDownList[] }>(),
);
export const addWorkArea = createAction('[Work Area] Add Work Area', props<{ workArea: IDropDownList }>());
export const removeWorkArea = createAction('[Work Area] Remove Work Area', props<{ workAreaId: string }>());
export const updateWorkArea = createAction('[Work Area] Update Work Area', props<{ workArea: IDropDownList }>());
